export default __webpack_public_path__ + "static/media/Slide_5.c0490663.jpg";